import { removeAbbr } from '@/utils/time'
import { buildBarChartOptions, buildDataPointsByDay, fillDate } from '@/components/patient-stats/common/utils'
import * as R from 'ramda'
import moment from 'moment-timezone'
import { CHART_DATE_FORMAT } from '@/components/patient-stats/constants'
import { withSingularOrPluralLabel } from '@/utils/labels'
import { DataPoint } from '@/jsonapi/CommonTypes'

export function buildSedentaryTimeOptions(options: {
  resultStartTimestamp: number
  resultEndTimestamp: number
  timezone: string
  colors: Record<any, any> // vuetify theme
  sedentaryHours: DataPoint[]
}): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
  const { timezone, resultStartTimestamp, resultEndTimestamp, colors, sedentaryHours } = options

  // let nonZeroValues = sedentaryTime.filter(dp => dp.value != 0)
  // debugger;

  const xAxisLabels: string[] = [...fillDate(timezone, resultStartTimestamp, resultEndTimestamp)].map(timestamp =>
    String(timestamp)
  )

  const eqByTimestamps = R.curry(R.eqProps)('timestamp')
  // @ts-ignore
  const uniqSedentaryHours = R.uniqWith(eqByTimestamps)(sedentaryHours) as DataPoint[]

  const sedentaryHoursByDayMap: { [key: string]: number } = buildDataPointsByDay(uniqSedentaryHours, timezone)
  const seriesXData: Array<[string, number]> = Object.entries(sedentaryHoursByDayMap)
  const maxYValue = Math.min(Math.max(...Object.values(sedentaryHoursByDayMap), 4), 24) // 24

  let linesToMark = [5, 10, 15, 20]
  if (maxYValue < 10) {
    linesToMark = [2, 4, 6, 8]
  } else if (maxYValue < 20) {
    linesToMark = [4, 8, 12, 16]
  }

  return buildBarChartOptions({
    baseColor: colors.burgundy,
    lowValueColor: colors.teal,
    threshold: 22,
    markLines: linesToMark, //[5, 10, 15, 20],
    minYValue: 0,
    maxYValue,
    seriesXData,
    xAxisLabels,
    tooltipFormatter: params => {
      // @ts-ignore
      const data: [string, number] = params.value
      const dateLabel = moment(parseInt(data[0], 10))
        .tz(timezone)
        .format(removeAbbr(timezone, CHART_DATE_FORMAT.DAY_ABBR))
      return `${dateLabel} ${data[1].toFixed(1)} hours`
    },
    options: {
      grid: [{ x: '5%', y: '5%', width: '90%', height: '80%' } as echarts.EChartOption.Grid],
    },
    timezone,
  })
}
